import { Component, ElementRef, EventEmitter, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { FileDropLabelsModel } from "src/app/models/fileDrop.mode";

@Component({
  selector: 'app-file-drop',
  templateUrl: './file-drop.component.html',
  styleUrls: ['./file-drop.component.scss']
})
export class FileDropComponent {
  @Output() filesAdded: EventEmitter<Set<File>> = new EventEmitter<
    Set<File>
  >();

  @ViewChild("fileDropRef") fileDropEl: ElementRef;

  files: Set<File> = new Set();

  private unsubscribe: Subject<boolean> = new Subject();
  labels: FileDropLabelsModel;

  constructor(
    protected translate: TranslateService
  ) {
    this.translate.get(['fileDropComponent']).pipe(
      takeUntil(this.unsubscribe))
      .subscribe((value) => {
        this.labels = value['fileDropComponent'];
      });
  }

  onFilesDropped(event: any) {
    this.files = event;
    this.onFilesAdded(event);
  }
  
  onFilesAdded(event?: any) {
    if (!event) {
      this.files = this.fileDropEl.nativeElement.files;
    }
    this.filesAdded.emit(this.files);
  }

}